<template>
  <Dialog v-model="currentVisible" :title="$t('Multi-factor authentication')" width="500px">
    <p class="text">
      {{
        $t(
          'You’re about to deactivate your multi-factor authentication device. This will also invalidate your recovery codes.'
        )
      }}
    </p>
    <div class="text-right q-gutter-sm">
      <Alert type="danger" v-if="errorMsg">{{ errorMsg }}</Alert>
      <Button :label="$t('Cancel')" @click="currentVisible = false" color="standard" flat />
      <Button :label="$t('Deactivate')" @click="disableMfa" color="negative" :loading="loading" />
    </div>
  </Dialog>
</template>

<script>
import { mapActions } from 'vuex';
import sharedMessages from '@/i18n/langs';
import Button from '@design-system/components/Button.vue';
import Dialog from '@design-system/components/Dialog.vue';

import Alert from '@/components/uikit/Alert';

const messages = {
  en: {
    'Multi-factor authentication': 'Multi-factor authentication',
    'You’re about to deactivate your multi-factor authentication device. This will also invalidate your recovery codes.':
      'You’re about to deactivate your multi-factor authentication device. This will also invalidate your recovery codes.',
    Deactivate: 'Deactivate',
    'Deactivation successful.': 'Deactivation successful.',
  },
  ja: {
    'Multi-factor authentication': '2段階認証',
    'You’re about to deactivate your multi-factor authentication device. This will also invalidate your recovery codes.':
      '2段階認証を解除しようとしています。復元コードも無効化されます。',
    Deactivate: '2段階認証を無効化',
    'Deactivation successful.': '2段階認証が無効になりました。',
  },
};

export default {
  name: 'MyAccountMfaDialogActiveDeactivate',
  components: { Button, Dialog, Alert },
  props: { value: Boolean },
  i18n: { messages, sharedMessages },
  data() {
    return {
      loading: false,
      errorMsg: false,
    };
  },
  computed: {
    currentVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapActions('mfa', {
      deleteMfa: 'delete',
    }),

    async disableMfa() {
      try {
        // Log
        this.$alpha.logger.addBreadcrumb('Click Deactivation button.');

        // Start Request
        this.loading = true;
        await this.deleteMfa();

        // After Request
        this.currentVisible = false;
        await this.$alpha.notify.custom({
          message: this.$t('Deactivation successful.'),
          color: 'success',
        });
      } catch (error) {
        await this.$alpha.notify.custom({
          message: this.$t('Error Occurred'),
          color: 'danger',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.text {
  word-break: break-word;
}
</style>
